import { connect } from 'react-redux'
import PupilsComponent from './pupils-component'
import { getPupilsArray } from '../../stores/pupils/pupils.selectors'
import {
  getPupilsWithAllFilters,
  isShowingSelected
} from './pupils-component-redux/pupils-component.selectors'
import { unsetShowSelected } from './pupils-component-redux/pupils-component.actions'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { me }) => ({
  canAddPupil: me.account.policy.can_manage_students,
  actualPupilsListEmpty: !getPupilsArray(state).length,
  filteredPupilsEmpty: !getPupilsWithAllFilters(state).length,
  isShowingSelected: isShowingSelected(state)
})

const mapDispatchToProps = dispatch => ({
  showAll: () => dispatch(unsetShowSelected())
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PupilsComponent)
)
